import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { produce } from 'immer'

import Button from 'js/components/Button/Button'
import Checkbox from 'js/components/Checkbox/Checkbox'
import Flexer from 'js/components/Flexer/Flexer'
import Popover from 'js/components/Popover/Popover'
import Spacer from 'js/components/Spacer/Spacer'
import Text from 'js/components/Text/Text'

const PluginsOption = ({
    option: { value, label },
    plugins,
    setPlugins,
    menu,
    setMenu,
}) => {
    const { t } = useTranslation()

    const [showAddToMenuPrompt, setShowAddToMenuPrompt] = useState(false)

    const optionExistsInMenu = menu.find((el) => el.id === value)

    const handleChange = ({ target: { checked } }) => {
        if (
            (optionExistsInMenu && !checked) ||
            (!optionExistsInMenu && checked)
        ) {
            setShowAddToMenuPrompt(true)
        }

        if (checked) {
            setPlugins([...plugins, value])
        } else {
            setPlugins(
                produce((newState) => {
                    newState.splice(plugins.indexOf(value), 1)
                }),
            )
        }
    }

    const handleAddToMenu = () => {
        if (optionExistsInMenu) {
            setMenu(
                produce((newState) => {
                    newState.splice(
                        menu.findIndex((el) => el.id === value),
                        1,
                    )
                }),
            )
        } else {
            setMenu([
                ...menu,
                {
                    id: value,
                    type: 'plugin',
                },
            ])
        }

        setShowAddToMenuPrompt(false)
    }

    const message = optionExistsInMenu ? (
        <span>
            {t('entity-group.remove-type-from-navigation-prompt')}
            {value === 'files' && (
                <>
                    <br />
                    {t('entity-group.remove-type-from-navigation-prompt-files')}
                </>
            )}
        </span>
    ) : (
        t('entity-group.add-type-to-navigation-prompt')
    )

    return (
        <div>
            <Popover
                visible={showAddToMenuPrompt}
                onClickOutside={() => setShowAddToMenuPrompt(false)}
                placement="top-start"
                content={
                    <Spacer spacing="tiny" style={{ padding: '8px 12px 12px' }}>
                        <Text size="small" textAlign="center">
                            {message}
                        </Text>
                        <Flexer>
                            <Button
                                size="small"
                                variant="tertiary"
                                onClick={() => {
                                    setShowAddToMenuPrompt(false)
                                }}
                            >
                                {t('action.no-skip')}
                            </Button>
                            <Button
                                size="small"
                                variant="primary"
                                onClick={handleAddToMenu}
                            >
                                {t('action.yes-confirm')}
                            </Button>
                        </Flexer>
                    </Spacer>
                }
            >
                <div>
                    <Checkbox
                        key={`plugins-${value}`}
                        name={`plugins-${value}`}
                        onChange={handleChange}
                        label={label}
                        checked={plugins.includes(value)}
                        size="small"
                    />
                </div>
            </Popover>
        </div>
    )
}

export default PluginsOption
